import { render, staticRenderFns } from "./FoodDesc.vue?vue&type=template&id=0dbfaecf&scoped=true&"
import script from "./FoodDesc.vue?vue&type=script&lang=ts&"
export * from "./FoodDesc.vue?vue&type=script&lang=ts&"
import style0 from "./FoodDesc.vue?vue&type=style&index=0&id=0dbfaecf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbfaecf",
  null
  
)

export default component.exports